export const CDN_FILE_API_ENDPOINTS = {
    ADD_CDN_FILE: "/cms/add-cdn-file",
    UPDATE_CDN_FILE: "/cms/update-cdn-file",
    GET_CDN_FILE: "/cms/get-cdn-file-details",
}

export interface CDNFileData {
    releaseDate: string;
    isVisible: boolean;
    displayOrder: number | undefined;
    title: string;
    imageUrl: File | null;
    cdnFileId?: string;
}

export const defaultCDNFileData: CDNFileData = {
    releaseDate: "",
    isVisible: false,
    displayOrder: undefined,
    title: "",
    imageUrl: null,
    cdnFileId: undefined,
};